import PropTypes from 'prop-types';
import componentPropType from './componentPropType';

const componentsPropType = PropTypes.arrayOf(componentPropType);

export default componentsPropType;
